import React, { HTMLAttributes, useCallback } from 'react';

interface FreeFocusWrapperProps {
  children: React.ReactElement<HTMLAttributes<HTMLElement>>;
  /**
   * @default true
   */
  enabled?: boolean;
}

/**
 * Позволяет кликнуть на элемент без переноса фокуса на него. Когда может быть полезно:
 * отправка сообщения без скрытия клавиатуры на мобильных устройствах.
 * У переданного children должны быть пропсы onTouchEnd и onMouseDown.
 **/
export function FreeFocusWrapper(props: FreeFocusWrapperProps) {
  const { children, enabled = true, ...rest } = props;

  const onTouchEnd = useCallback(
    (e: React.TouchEvent<HTMLElement>) => {
      children.props.onTouchEnd?.(e);
      e.preventDefault();
      e.target.dispatchEvent(new MouseEvent('click', { bubbles: true }));
    },
    [children.props],
  );

  const onMouseDown = useCallback(
    (e: React.MouseEvent<HTMLElement>) => {
      children.props.onMouseDown?.(e);
      e.preventDefault();
    },
    [children.props],
  );

  /* Добавление onTouchEnd, onMouseDown потомкам */

  const child = React.cloneElement(children, enabled ? { onTouchEnd, onMouseDown, ...rest } : rest);

  return <>{child}</>;
}
